import { render, staticRenderFns } from "./KRA-main.vue?vue&type=template&id=53036059&scoped=true&"
import script from "./KRA-main.vue?vue&type=script&lang=js&"
export * from "./KRA-main.vue?vue&type=script&lang=js&"
import style0 from "./KRA-main.vue?vue&type=style&index=0&id=53036059&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53036059",
  null
  
)

export default component.exports